import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, text, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Contributor } from '../contributor'
import { Book } from './book'

export const BookToContributor = pgTable(
  'book_to_contributor',
  {
    id: uuid().primaryKey().defaultRandom(),
    bookId: uuid()
      .notNull()
      .references(() => Book.id, { onDelete: 'cascade' }),
    contributorId: uuid()
      .notNull()
      .references(() => Contributor.id, { onDelete: 'cascade' }),
    type: text({ enum: ['author', 'illustrator'] }).notNull(),
  },
  (table) => [
    index('book_to_contributor_book_idx').on(table.bookId),
    index('book_to_contributor_contributor_idx').on(table.contributorId),
  ],
)

export const bookToContributorRelations = relations(BookToContributor, ({ one }) => ({
  book: one(Book, {
    fields: [BookToContributor.bookId],
    references: [Book.id],
  }),
  contributor: one(Contributor, {
    fields: [BookToContributor.contributorId],
    references: [Contributor.id],
  }),
}))

export const InsertBookToContributorSchema = createInsertSchema(BookToContributor).omit({ id: true })
export const UpdateBookToContributorSchema = createUpdateSchema(BookToContributor).partial().omit({ id: true })
export const SelectBookToContributorSchema = createSelectSchema(BookToContributor)

export type InsertBookToContributor = typeof BookToContributor.$inferInsert
export type UpdateBookToContributor = z.infer<typeof UpdateBookToContributorSchema>
export type SelectBookToContributor = typeof BookToContributor.$inferSelect
